module.exports = __webpack_public_path__ + "static/media/market.f47ad1e7.png";